import React from "react";

function Cart() {
    return (
        <div>
            <section className="internal-page-wrapper">
                <div className="container">
                    <div className="row h-100 align-center justify-content-center text-center">
                        <div className="col-12 mt-5 pt-5">
                            <h1 className="font-weight-bold">Cart Page</h1>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Cart;
